module.exports = __webpack_public_path__ + "static/media/view4.ded1b464.jpg";